import { Sparkle } from "lucide-react";

export const Marquee = ({ items }) => (
  <div
    className="relative overflow-hidden border-y border-white/[0.07] bg-obsidian/40 py-6"
    data-testid="editorial-marquee"
  >
    <div className="animate-marquee flex w-max whitespace-nowrap">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
          {items.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="font-display text-lg sm:text-xl font-medium text-slate-400">
                {item}
              </span>
              <Sparkle className="mx-10 h-3.5 w-3.5 text-cyan-400/70" fill="currentColor" />
            </span>
          ))}
        </div>
      ))}
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-void to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-void to-transparent" />
  </div>
);
